export default __webpack_public_path__ + "adobe-xd.e5482c0a.png";